import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
} from "firebase/auth";
import Cookies from "js-cookie";

import { useState, useEffect } from "react";
import { authentication } from "../firebase-config";

const formatAuthUser = (user: any) => ({
  uid: user.uid,
  email: user.email,
  phone: user.phoneNumber,
  name: user.name,
  firstname: user.firstname,
});

export default function useFirebaseAuth() {
  const [authUser, setAuthUser] = useState<any>(null);
  const [loggedUser, setLoggedUser] = useState<any>(null);

  const [loading, setLoading] = useState(true);

  const authStateChanged = async (authState: any) => {
    if (!authState) {
      setLoading(false);
      clear();
      return;
    }

    setLoading(true);

    var formattedUser = formatAuthUser(authState);

    setAuthUser(formattedUser);
    setLoading(false);
  };

  const clear = () => {
    setAuthUser(null);
    setLoggedUser(null);
    setLoading(true);
  };

  const emailAndPassLogin = async (email: string, password: string) => {
    signInWithEmailAndPassword(authentication, email, password);
  };

  const emailAndPassRegister = async (email: string, password: string) => {
    createUserWithEmailAndPassword(authentication, email, password);
  };

  const googleRegisterAndLogin = async () => {
    authentication.languageCode = "en";
    const gProvider = new GoogleAuthProvider();
    signInWithPopup(authentication, gProvider);
  };

  const logOut = async () => {
    signOut(authentication)
      .then(() => {
        console.log("SUCCESS WHILE SIGN OUT");
        clear();
        //  window.location.reload();
      })
      .catch(() => {
        console.error("ERROR WHILE SIGN OUT");
      });
    //firebase.auth().signOut().then(clear);
  };

  useEffect(() => {
    const lUser = Cookies.get("auth_token");
    setLoggedUser(lUser);
    const unsubscribe = onAuthStateChanged(authentication, authStateChanged);
    return () => unsubscribe();
  }, []);

  return {
    authUser,
    loggedUser,
    loading,
    emailAndPassLogin,
    emailAndPassRegister,
    googleRegisterAndLogin,
    logOut,
  };
}
